import { Component, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { iValidatedControl } from '../iValidatedControl';
import { BaseCustomControl } from '../baseCustomControl';
import { HostBinding } from '@angular/core';
import { ElementRef, ViewChild } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { ListItem } from '../../../../../../../../libs/Shared/components/model/listItem';
export enum DDLModes {
  Default = "Default",
  States = "States",
  Countries = "Countries",
  CCProcessors = "CCProcessors",
  ACHProcessors = "ACHProcessors",
  Gateways = "Gateways",
  Brands = "Brands",
  TimeZones = "TimeZones",
  BusinessTypes = "BusinessTypes",
  UnitsOfMeasure = "UnitsOfMeasure",
  TaxTypes = "TaxTypes",
  ProcessingTypes = "ProcessingTypes"
}

@Component({
  selector: 'app-selectbox',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './selectbox.html',
  styles:  ``,
})
export class Selectbox extends BaseCustomControl implements ControlValueAccessor, iValidatedControl {

  @HostBinding('class.formField') formFieldClass = true; // Always applied
  @HostBinding('class.readOnly') get isReadOnly() {
    return this.readonly;
  }


  @Input() align:string = "";
  @Input() options:ListItem[] = [];
  @Input() validationLocation:string = "right"; // right | under
  @Input() type:DDLModes = DDLModes.Default;
  @Input() showRequired:boolean = false;
  @Input() L2L3Required:boolean = false;
  @Input() multiple:boolean = false;

  @ViewChild('container') container:ElementRef<HTMLSelectElement>|undefined;

  constructor(changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef);
  }


  override ngOnInit(): void {
    super.ngOnInit();

    this.validationMsg = "Invalid";
    this.isValid = false;
  }

  private setInitialValue() {
    if (this.boundValue && this.options) {
      // Ensure the option exists in the dropdown
      const exists = this.options.some(opt => opt.id === this.boundValue);
      if (!exists) {
        // If the bound value isn't in options, clear it
        this.boundValue = undefined;
      }
    }
  }

  ngAfterViewInit() {

    if (!this.readonly) {
      let c:HTMLSelectElement = document.getElementById(this.myId) as HTMLSelectElement; //document.getElementsByClassName("floatSelect")[0] as HTMLSelectElement;
      c.setAttribute("data-selected-index", "-1")
    }

    // TODO:This causes issues with change detection. If the only point of calling 
    // validation here is to force visibility of the required tags, then we
    // should do something different.

    // if (this.showRequired) {
    //   this.validate();
    // }
  }

  get value():string {
    if (this.boundValue && !this.multiple) {
      return this.boundValue.trim();
    } else if(this.boundValue && this.multiple) {
      return this.boundValue.join(",");
    } else {
      return "";
    }
  }

  public lookupOptions(key:string) {
    // if (this.type == DDLModes.States) {
    //   this.cache.getStatesList(key)
    //   .then(s => {
    //     this.options = s;
    //   })
    // }
  }

  
  public clearSelection() {
    this.boundValue = undefined;
  }


  private _computeIsValid(): boolean {
    console.log({ value: this.value, required: this.required });
    if (this.required && this.value == "") {
      return false;
    }
    return true;
  }
  
  // Read-only check — safe to call on every keystroke/change, no UI side effects
  public checkValiditySilently(): boolean {
    return this._computeIsValid();
  }
  
  public validate(): boolean {
    this.isValid = this._computeIsValid();
    this.validationMsg = this.isValid ? "" : "required";
  
    if (!this.isValid) {
      this._handle_validateFailed();
    }
    else {
      this._handle_validatePassed();
    }
  
    return this.isValid;
  }

  // private updateSelectedIndex() {
  //   if (this.boundValue && this.boundValue != "") {
  //     for (var i=0; i<this.options.length; i++) {
  //       if (this.options[i].id == this.boundValue) {
  //         this.selectedIndex = i;
  //         break;
  //       }
  //     }  
  //   }
  //   else {
  //     this.selectedIndex = -1;
  //   }
  // }

  _handle_change(e:Event) {

   
    let c:HTMLSelectElement = e.target as HTMLSelectElement;
    c.setAttribute("data-selected-index", c.selectedIndex.toString())

    if (this.validateOn == "change") {
      this.validate();
    }

    this.onChange(this.boundValue);

    this.onChanged.emit(this.boundValue);

    return true;
  }

  _handle_onBlur(e:FocusEvent) {

    this.validate();
  }
}
